import React from 'react';
import VersusSelector from './VersusSelector';
import VersusChart from './VersusChart';
import VersusRanking from './VersusRanking';

/**
 * Renderiza el bloque VersusView de SCAPP V2.
 *
 * @param {object} props
 * @param {object} props.v - Modelo de presentación y callbacks del panel.
 * @returns {React.ReactNode} Bloque visual sin estado local.
 */
export default function VersusView({
  v
}) {
  return v.viewVs ? React.createElement(React.Fragment, null, v.text("\n  "), React.createElement("div", {
    style: {
      "flex": "1",
      "minHeight": "0",
      "display": "grid",
      "gridTemplateColumns": "minmax(0,1fr) 34.375vw minmax(0,1fr)",
      "gap": "1.111111vh"
    }
  }, v.text("\n    "), React.createElement(VersusSelector, {
    v
  }), v.text("\n    "), React.createElement(VersusChart, {
    v
  }), v.text("\n    "), React.createElement(VersusRanking, {
    v
  }), v.text("\n  ")), v.text("\n  ")) : null;
}
